import React from 'react';
import { UserType } from '../types';
import { useAuthUserContext } from '../providers'
import { Navigate, useLocation } from 'react-router-dom';

type Props = {
  component: React.ReactNode,
  redirect: string,
  allowedUserTypes?: UserType[]
}

export const RouteAuthGuard: React.VFC<Props> = (props) => {
  const authUser = useAuthUserContext().user;

  let allowedRoute = false;
  if (authUser) {
    allowedRoute = props.allowedUserTypes ? props.allowedUserTypes.includes(authUser.userType) : true;
  }

  const location = useLocation();
  if (!allowedRoute) {
    return <Navigate to={ props.redirect } state={{ from: location }} replace={ false } />
  }

  return <>{ props.component }</>;

}
